import React from 'react';
import ReviewContent from 'components/reviewer/review/ReviewContent';

export const ReviewPage: React.FC = () => {
  return <ReviewContent />;
};
